const getRequestConfig = () => ({
    headers: { "Authorization": localStorage.getItem("Authorization") }
})

export default getRequestConfig